<template>
    <div class="head">
        <div v-if="entity[component]?.properties?.TITLE || entity_data?.title || entity[component]?.title"
            class="title">
            <h1>{{ entity[component]?.properties?.TITLE || entity_data?.title || entity[component]?.title }}</h1>
        </div>
    </div>
    <div v-if="entity[component]?.metas" class="container flex wrap center vcenter"
        :class="{ 'dialog': entity[component]?.properties?.dialog === 'YES' }">
        <form class="flex wrap initial" :class="[{ 'fullwidth': entity[component]?.properties?.fullwidth === 'YES' }]">
            <Fields :entity_type="entity_type" :id="id" :component="component" :entity="entity" :contents="contents"
                :accesses="accesses" :focus="focus" :errors="errors" :files="files" :dynamic="dynamic"
                :internal="internal" @onfocus="(obj) => focus = obj.focus" @onchange="(obj) => {
                    models = obj.models
                    hints = obj.hints
                    errors = obj.errors
                }" @onextras="(obj) => this.extras = obj.extras"
                @onvisibilities="(obj) => this.visibilities = obj.visibilities" @onloading="onloading"></Fields>

            <template
                v-for="(meta, index) in entity[component]?.metas?.filter((meta) => { return meta.type === 'form' })"
                :key="index">
                <div v-if="meta.type === 'form'" v-show="visibilities[meta.key] === 'visible'" class="form">
                    <Form :entity_type="extras[component] ? extras[component][meta.key]?.entity_type : ''"
                        :entity_data="_entity_data(meta.name, extras[component] ? extras[component][meta.key] : {})"
                        @onchange="(obj) => {
                            Object.keys(obj.models).forEach((key) => {
                                let _key = extras[component]?.[meta.key]?.[key]
                                this.models[this.component][_key || key] = obj.models[key]
                            })
                        }">
                    </Form>
                </div>
            </template>

            <div class="flex wrap center vcenter">
                <template v-for="(button, index) in entity[component]?.buttons" :key="index">
                    <Button
                        v-if="!String(button?.action)?.includes('copy') || (String(button?.action)?.includes('copy') && id)"
                        :meta="button" :active="loading[button.key]" :disabled="disabled[button.key]" @onclick="(meta) => String(meta?.action)?.includes('popup')
                            ? open(meta)
                            : String(meta?.action)?.includes('copy')
                                ? oncopy(String(meta?.action)?.split(':')[1])
                                : String(meta?.action).includes('route')
                                    ? route(meta)
                                    : onsubmit(meta)">
                    </Button>
                </template>
            </div>

            <Reply v-if="process" :meta="{
                key: 'comments',
                name: 'کامنت کارشناسان'
            }" :id="id" :disabled="true">
            </Reply>
        </form>
    </div>
    <Dialog :data="dialog[dialog.active]" :show="dialog['show']" @onclose="() => dialog['show'] = false" @onresult="(obj) => {
        if (obj === true)
            onsubmit(dialog['meta'], dialog.active === 'validate'
                ? true
                : false)
        else if (obj !== 'edit')
            base.Notification().error({ code: 401 })
        else
            this.loading[dialog['meta'].key] = false
        dialog['show'] = false
    }" @onsubmit="dialog['onsubmit']">
    </Dialog>
</template>

<script>
/* eslint-disable */
import Form from './Form.vue'
import Button from './Form/Button.vue'
import Fields from './Form/Fields.vue'
import Reply from './Form/Inputs/Reply.vue'
import Dialog from './Dialog.vue'

import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
    name: 'Form',
    props: ['entity_type', 'entity_data', 'id', 'contents', 'center', 'internal'],
    inject: ['base', 'entities'],
    components: { Form, Fields, Reply, Button, Dialog },
    created() {
        this.init()
    },
    data() {
        return {
            component: `form-${this.base.Util().hash(4)}`,
            entity: {},
            extras: {},
            loading: {},
            accesses: {},
            disabled: {},
            visibilities: {},
            models: {},
            hints: {},
            focus: '',
            errors: {},
            files: [],
            temporaryid: '',
            dynamic: false,
            dialog: {},
            process: false
        }
    },
    watch: {
        entity_type(newEntity, oldEntity) {
            this.init()
        },
        $route(newRoute, oldRoute) {
            if (newRoute.params.entity_type === oldRoute.params.entity_type
                && (!newRoute.params.id || newRoute.params.id === ''))
                location.reload()
        },
        models: {
            handler(newModels, oldModels) {
                this.$emit('onchange', {
                    models: Object.keys(this.models[this.component])
                        .filter((key) => { return this.entity[this.component]?.properties?.allowed?.includes(key) })
                        .reduce((obj, key) => {
                            obj[key] = this.models[this.component][key]
                            return obj
                        }, {})
                })
            },
            deep: true
        }
    },
    methods: {
        _entity_data(title, extras) {
            return {
                title: title,
                properties: {
                    allowed: extras?.allowed,
                    excludes: extras?.excludes,
                    query: this._query(extras),
                    ADD: 'NO',
                    REMOVE: 'NO',
                    EXPORT: extras?.export,
                    options: extras?.options,
                    SUBFORM: true,
                    SUBLIST: true,
                },
                options: {}
            }
        },
        _query(extras) {
            if (Array.isArray(extras?.query))
                return extras?.query?.reduce((obj, key) => {
                    obj[key] = String(extras?.[key])?.includes('params')
                        ? this.$route.params[String(extras?.[key]).replace('params(', '').replace(')', '')] || 'NaN'
                        : extras?.[key].includes('key')
                            ? this.models[this.component]?.[String(extras?.[extras?.key]).replace('key(', '').replace(')', '')] || 'NaN'
                            : extras?.[key]
                    return obj
                }, {})
            else {
                let obj = {}
                let value = String(extras?.[extras?.query])?.includes('params')
                    ? this.$route.params[String(extras?.[extras?.query]).replace('params(', '').replace(')', '')] || 'NaN'
                    : String(extras?.[extras?.query]).includes('key')
                        ? this.models[this.component]?.[String(extras?.[extras?.query]).replace('key(', '').replace(')', '')] || 'NaN'
                        : extras?.[extras?.query]
                if (value)
                    obj[extras?.query] = value
                return obj
            }
        },
        init() {
            this.entity[this.component] = {}
            if (this.entity_type) {
                if (this.entity_data?.metas) {
                    this.load()
                } else {
                    this.$emit('onloading', true)
                    this.base.API().post(`Data/Entity/Find`, {
                        entity_type: this.entity_type.toUpperCase(),
                        options: 'FORM',
                        data: this.id || null
                    }, (response) => {
                        if (this.base.Util().success(response) && response.data.data) {
                            if (!this.id)
                                this.$emit('onloading', false)
                            this.load(response.data.data)
                        } else
                            this.$emit('onloading', false)
                    }, (error) => this.$emit('onloading', false))
                }
            }
        },
        load(data) {
            this.entity[this.component] = data || { properties: {}, options: {}, metas: [], buttons: [] }
            if (!this.entity[this.component])
                this.entity[this.component] = {}
            if (this.entity_data && this.entity[this.component]) {
                this.entity[this.component].title = this.entity_data.title
                this.entity[this.component].properties = Object.assign(this.entity[this.component]?.properties || {}, this.entity_data.properties)
                this.entity[this.component].options = Object.assign(this.entity[this.component]?.options || {}, this.entity_data.options)

                if (this.entity_data?.metas)
                    this.entity[this.component].metas = (this.entity_data?.metas || []).concat(this.entity[this.component]?.metas || [])
                        .reduce((meta, obj) => {
                            if (!meta.find(o => o.entity_type === obj.entity_type && o.key === obj.key))
                                meta.push(obj)
                            return meta
                        }, [])

                if (this.entity_data?.accesses)
                    this.entity[this.component].accesses = (this.entity_data?.accesses || []).concat(this.entity[this.component]?.accesses || [])
                        .reduce((access, obj) => {
                            if (!access.find(o => o.data === obj.data))
                                access.push(obj)
                            return access
                        }, [])

                if (this.entity_data?.properties?.SUBFORM)
                    this.entity[this.component].buttons = []
                else if (this.entity_data?.buttons)
                    this.entity[this.component].buttons = (this.entity_data?.buttons || []).concat(this.entity[this.component]?.buttons || [])
                        .reduce((button, obj) => {
                            if (!button.find(o => o.key === obj.key))
                                button.push(obj)
                            return button
                        }, [])
            }

            this.dynamic = ['ACCOUNT', 'GROUP', 'ROLE', 'FOLDER', 'FINANCING', 'FILE', 'POST', 'CATEGORIZE', 'TAG']
                .includes(this.entity_type.toUpperCase())

            for (const element of this.entity[this.component]?.accesses?.filter((access) => {
                return access.data.toUpperCase().startsWith(`${this.entity_type.toUpperCase()}_FORM`)
                    || access.data.toUpperCase().startsWith(`${this.entity_type.toUpperCase()}_RFORM`)
                    || access.data.toUpperCase().startsWith(`${this.entity_type.toUpperCase()}_UFORM`)
                    || access.data === 'PERSIST'
            })) {
                if (element.data.includes(`${this.entity_type.toUpperCase()}_UFORM`)) {
                    if (this.base.Util().validate(this.id))
                        this.accesses[element.data.replaceAll(`${this.entity_type.toUpperCase()}_UFORM(`, '')
                            .replaceAll(')', '').toLowerCase()] = element.action.toLowerCase()
                }
                else if (element.data.includes(`${this.entity_type.toUpperCase()}_RFORM`)) {
                    if (!this.base.Util().validate(this.id))
                        this.accesses[element.data.replaceAll(`${this.entity_type.toUpperCase()}_RFORM(`, '')
                            .replaceAll(')', '').toLowerCase()] = element.action.toLowerCase()
                }
                else
                    this.accesses[element.data.replaceAll(`${this.entity_type.toUpperCase()}_FORM(`, '')
                        .replaceAll(')', '').toLowerCase()] = element.action.toLowerCase()
            }

            this.process = this.base.Util().validate(this.id)
                && (Number(this.entity[this.component]?.properties['PROCESS'] || '0') || 0 > 0)

            this.dialog = {
                verify: {
                    type: 'verify',
                    title: 'تائیدیه',
                    thin: true,
                    internal: true,
                    closeable: true
                },
                validate: {
                    type: 'validate',
                    title: 'تائیدیه اطلاعات',
                    closeable: false
                },
                comment: {
                    type: 'comment',
                    title: 'کامنت کارشناس',
                    thin: true,
                    internal: true,
                    closeable: false
                },
                meta: {},
                active: 'verify',
                show: false
            }
        },
        open(meta, dialog, onsubmit) {
            dialog = dialog || String(meta?.action)?.split('_')[1]
            this.dialog['meta'] = meta
            this.dialog[dialog]['models'] = this.models[this.component]
            this.dialog[dialog]['metas'] = this.entity[this.component].metas?.filter((meta) => {
                return meta.entity_type === this.entity_type.toUpperCase()
                    && (!['form', 'list', 'profile', 'files', 'file', 'dropdown', 'multidrop', 'tab', 'multiparams', 'span'].includes(meta.type))
                    && this.visibilities[meta.key] === 'visible'
            })
            if (onsubmit)
                this.dialog['onsubmit'] = onsubmit
            this.dialog['active'] = dialog
            this.dialog['show'] = !this.dialog['show']
        },
        parse(meta, value) {
            if (meta.type === 'multiparams') {
                value = ''
                for (const key of Object.keys(this.models[this.component][meta.key] || {})) {
                    let data = ''
                    try {
                        for (const property of Object.keys(this.models[this.component][meta.key][key]))
                            if (this.models[this.component][meta.key][key][property].prototype !== 'FILE')
                                data += this.base.Util().validate(data)
                                    ? `,${property}=${this.models[this.component][meta.key][key][property]}`
                                    : `${property}=${this.models[this.component][meta.key][key][property]}`
                            else {
                                let file = this.models[this.component][meta.key][key][property]
                                if (!file.source) {
                                    file.extras = `${meta.key}:${key}:${property}`
                                    this.files.push(file)
                                }
                            }
                    } catch (e) {
                    }

                    value += this.base.Util().validate(value)
                        ? `;${key}:${data}`
                        : `${key}:${data}`
                }
            }
            else if (this.dynamic)
                if (meta.type === 'switch')
                    value = value && (String(value).toLowerCase() === 'true' || value === true) ? 'True' : 'False'
                else
                    value = String(value || '')
            else
                if ((meta.type === 'number' || meta.type === 'amount'))
                    value = value ? Number(String(value).replaceAll(/,/g, '')) : 0
                else if (meta.type === 'switch')
                    value = value && (String(value).toLowerCase() === 'true' || value === true) ? true : false
                else if (meta.type === 'date')
                    value = String(value).length === 10
                        ? Number(this.base.Util().time({ date: value }))
                        : Number(value)
                else if (meta.type === 'dropdown')
                    value = value && !isNaN(value) ? Number(value) : value
            return value
        },
        oncopy(key) {
            navigator.clipboard.writeText(this.models[this.component][key])
            const meta = this.entity[this.component].metas.find(meta => meta.key === key)
            this.base.Notification().toast('نتیجه عملیات', meta ? `${meta.name} شما کپی شد!` : 'کپی شد!', 'info')
        },
        route(meta) {
            let endpoint = meta?.endpoint
            for (const key of Object.keys(this.models[this.component]))
                if (endpoint.includes(`{${key}}`))
                    endpoint = endpoint.replaceAll(`{${key}}`, `${this.models[this.component][key]}`)
            endpoint = `${endpoint.split('?')[0]}?return=${window.location.pathname}&${endpoint.split('?')[1]}`
            if (meta?.action === 'route')
                this.$router.push(endpoint)
            else
                window.open(endpoint)
        },
        async onsubmit(meta, passthrough = false) {
            let pass = true
            this.loading[meta.key] = true
            if (!meta.passthrough)
                this.entity[this.component].metas
                    .filter((meta) => meta.entity_type === this.entity_type.toUpperCase())
                    .forEach((meta) => {
                        if (this.visibilities[meta.key] !== 'gone') {
                            if ((!this.errors[this.component][meta.key] || this.errors[this.component][meta.key] === false)
                                && !(meta.type === 'multiparams' || meta.type === 'switch'))
                                this.errors[this.component][meta.key] = meta.required && (!this.base.Util().validate(this.models[this.component][meta.key]))
                            if (this.errors[this.component][meta.key] === true) {
                                this.focus = meta.key
                                this.base.Notification().error({ code: 1000, text: meta.name })
                                pass = false
                            } else if (meta.type === 'multiparams') {
                                Object.keys(this.models[this.component][meta.key] || {}).forEach((key) => {
                                    this.entity[this.component].metas?.filter((element) => {
                                        return element.entity_type === `${this.entity_type.toUpperCase()}_${meta.key.toUpperCase()}`
                                    }).forEach((element) => {
                                        if (!this.errors[this.component][meta.key])
                                            this.errors[this.component][meta.key] = {}
                                        if (!this.errors[this.component][meta.key][key])
                                            this.errors[this.component][meta.key][key] = {}

                                        if (element.type !== 'switch') {
                                            this.errors[this.component][meta.key][key][element.key] = element.required && (!this.base.Util().validate(this.models[this.component][meta.key][key][element.key]))
                                            if (this.errors[this.component][meta.key][key][element.key] === true) {
                                                this.base.Notification().error({ code: 1000, text: `"${element.name}" در ${meta.name} ردیف "${key.replaceAll('R', '')}"` })
                                                pass = false
                                            }
                                        }
                                    })
                                })
                            }
                        }
                    })

            if (pass) {
                let values = []
                let parent_id = this.base.Util().validate(this.id)
                    ? this.id
                    : '00000000-0000-0000-0000-000000000000'
                this.entity[this.component].metas.forEach((meta) => {
                    if (meta.entity_type === this.entity_type.toUpperCase()) {
                        if (meta.type !== 'file' && meta.type !== 'files' && meta.type !== 'span' && meta.type !== 'step') {
                            let id = 0
                            if (this.dynamic && this.values) {
                                let value = this.values.find((value) => value.key === meta.key)
                                if (value)
                                    id = value.id
                            }

                            values.push({
                                id: id,
                                parent_id: parent_id,
                                key: meta.key,
                                value: this.parse(meta, this.models[this.component][meta.key])
                            })
                        } else if ((meta.type === 'file' || meta.type === 'files')
                            && this.base.Util().validate(this.models[this.component][meta.key]))
                            if (Array.isArray(this.models[this.component][meta.key])
                                && this.models[this.component][meta.key].length > 0)
                                this.models[this.component][meta.key].forEach((file) => {
                                    if (!file.source)
                                        this.files.push(file)
                                })
                            else if (!this.models[this.component][meta.key].source)
                                this.files.push(this.models[this.component][meta.key])
                    }
                })

                if (this.entity[this.component]?.properties?.VALIDATE === 'YES' && !passthrough)
                    this.open(meta, 'validate')
                else {
                    const files = this.files.filter(file => { return file.raw })
                    if (this.base.Util().validate(files)) {
                        let response = await this.base.API().upload(this.id
                            ? `${this.entity_type?.toUpperCase()}_${this.id}`
                            : this.temporaryid || '', files)
                        if (this.base.Util().success(response)) {
                            if (this.base.Util().validate(response.data.temporaryid))
                                this.temporaryid = response.data.temporaryid

                            if (this.base.Util().validate(response.data.uploads)) {
                                let files = []
                                this.files.forEach(file => {
                                    if (!response.data.uploads.find(upload =>
                                        upload.name === `${file.name}|${file.extras}` && upload.status === 'success'))
                                        files.push(file)
                                })
                                this.files = files
                            }
                        }

                        if (this.base.Util().validate(this.files)) {
                            this.files.forEach((file) =>
                                this.base.Notification().error({ code: 1005, text: file.name }))
                            pass = false
                        } else
                            this.base.Notification().toast('نتیجه عملیات', 'بارگذاری فایل‌ها با موفقیت انجام گردید!', 'success')
                    }

                    if (pass) {
                        if (String(meta?.action).includes('comment'))
                            this.open(meta, 'comment', onsubmit = (obj) => {
                                this.dialog['show'] = false
                                this.submit(values, meta, obj)
                            })
                        else
                            this.submit(values, meta)
                    }
                    else
                        this.loading[meta.key] = false
                }
            } else
                this.loading[meta.key] = false
        },
        submit(values, meta, comment) {
            this.base.Entities().submit({
                entity_type: this.entity_type.toUpperCase(),
                properties: this.entity[this.component].properties,
                options: this.entity[this.component].options,
                dynamic: this.dynamic,
                id: this.id,
                temporaryid: this.temporaryid,
                data: values,
                meta: meta,
                comment: comment
            }, (obj) => {
                this.loading[meta.key] = false
                this.$emit('onresult', obj)
            })
        },
        onloading(status) {
            this.$emit('onloading', status)
        }
    }
}
</script>

<style src="../assets/css/components/form.css" />